import FeedbackOperationEnum from "constants/FeedbackOperationEnum";
import FeedbackTypeEnum from "constants/FeedbackTypeEnum";
import { BaseModel } from "sjs-base-model";

export default class FeedbackModel extends BaseModel {
    public readonly id: string = "";
    public readonly type: FeedbackTypeEnum = FeedbackTypeEnum.Error;
    public readonly operation: FeedbackOperationEnum | undefined = undefined;
    public readonly message: string = "";
    public readonly description: string = "";

    constructor(data: Partial<FeedbackModel>) {
        super();

        this.update(data);
    }
}
